import { BaseComponentProps } from "./types";

export const baseAttrs = ({ id, testId, trackingId, className }: BaseComponentProps) => {
	return {
		id: id ? id : undefined,
		"data-testid": testId ? testId : undefined,
		"data-pendo-id": trackingId ? trackingId : undefined,
		"data-amp-track-id": trackingId ? trackingId : undefined,
		className: className ? className : undefined,
	};
};

/**
 * Keeps generated id segments kebab-case when they are derived from a camelCase
 * source (multiform step names, mostly), so dashboard filters don't have to be
 * case-sensitive to match them.
 */
export const trackingSegment = (value: string) =>
	value.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

export const trackingAttrs = (trackingId?: string) =>
	trackingId
		? {
				"data-pendo-id": trackingId,
				"data-amp-track-id": trackingId,
			}
		: undefined;
